"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductShades = void 0;
var _fetching = require("@ori/fetching");
var _fragments = require("./fragments");
/* istanbul ignore file @preserve */

const getProductShades = exports.getProductShades = (0, _fetching.gql)`
  ${_fragments.shades}
  query GetProductShades($productCode: ID!) {
    product(productCode: $productCode) {
      pdpUrl {
        relativeUrl
      }
      concept {
        name
        products {
          ...ShadePickerShade
        }
      }
    }
  }
`;
